import React from "react";
import "./NotFound.css";
import { useNavigate, useLocation } from "react-router-dom";

const NAV_ITEMS = [
    {
        label: "Dashboard",
        path: "/Dashboard",
        icon: (
            <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="7" height="7" rx="1" />
            </svg>
        ),
    },
    {
        label: "Showroom",
        path: "/showroom",
        icon: (
            <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
        ),
    },
    {
        label: "Settings",
        path: "/settings",
        icon: (
            <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
        ),
    },
];

const FourHundredError = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const rawPath = location.pathname;
    const displayPath = rawPath.length > 48 ? rawPath.slice(0, 45) + "…" : rawPath;

    return (
        <div className="e404-root">
            <div className="e404-panel">
                {/* ── Left: content ── */}
                <div className="e404-content">
                    <span className="e404-eyebrow">Error 404</span>

                    <div className="e404-numeral" aria-hidden="true">
                        404
                    </div>

                    <h1 className="e404-headline">Page not found</h1>
                    <p className="e404-body">
                        This URL doesn't exist in our system. It may have been moved, deleted, or you may have followed
                        a broken link.
                    </p>

                    <div className="e404-url-badge" title={rawPath}>
                        <span className="e404-url-label">Requested path</span>
                        <code className="e404-url-path">{displayPath}</code>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FourHundredError;
